import React from 'react';
import JudgeScoringPageRotation from './JudgeScoringPageRotation';

export default function FloorScoring() {
  return <JudgeScoringPageRotation apparatus="wagfloor" />;
}
